var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPreceiveicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65563",
    "data-name": "Grupo 65563",
    transform: "translate(-1104 -784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_15502",
    "data-name": "Ret\\xE2ngulo 15502",
    transform: "translate(1104 784)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65552",
    "data-name": "Grupo 65552",
    transform: "translate(4419 7182.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95862",
    "data-name": "Caminho 95862",
    d: "M112.5,25h-9a.9.9,0,0,1-.344-.069.9.9,0,0,1,0-1.663.9.9,0,0,1,.344-.068h9a.9.9,0,0,1,.344.068.9.9,0,0,1,0,1.663A.9.9,0,0,1,112.5,25Zm1.78-11.32V5.59A3.68,3.68,0,0,0,110.53,2h-5a3.68,3.68,0,0,0-3.75,3.59v8.09a3.68,3.68,0,0,0,3.75,3.59h5a3.68,3.68,0,0,0,3.75-3.59ZM110.53,3.8a1.829,1.829,0,0,1,1.88,1.79v8.09a1.84,1.84,0,0,1-1.88,1.8h-5a1.842,1.842,0,0,1-1.313-.511,1.837,1.837,0,0,1-.567-1.289V5.59a1.824,1.824,0,0,1,.568-1.286,1.831,1.831,0,0,1,1.312-.5ZM120,16V8.65A5.388,5.388,0,0,0,117.25,4a.922.922,0,1,0-1,1.55,3.583,3.583,0,0,1,1.83,3.09V16a3.671,3.671,0,0,1-3.74,3.59H101.62A3.67,3.67,0,0,1,97.88,16V8.65a3.58,3.58,0,0,1,1.83-3.09A.89.89,0,0,0,100,4.32,1,1,0,0,0,98.75,4,5.39,5.39,0,0,0,96,8.65V16a5.52,5.52,0,0,0,5.62,5.39h12.76A5.521,5.521,0,0,0,120,16Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95863",
    "data-name": "Caminho 95863",
    d: "M106.45,7.39h3.14a.9.9,0,0,0,0-1.8h-3.14a.9.9,0,1,0,0,1.8Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95864",
    "data-name": "Caminho 95864",
    d: "M109.59,8.74a.9.9,0,0,1,.831.556.9.9,0,0,1-.195.981.9.9,0,0,1-.636.264h-3.14a.9.9,0,1,1,0-1.8Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95865",
    "data-name": "Caminho 95865",
    d: "M107.72,11.88a.9.9,0,0,1,0,1.8h-1.27a.9.9,0,1,1,0-1.8Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPreceiveicon);
export default __webpack_public_path__ + "static/media/LPreceiveicon.263d442ac249d44cd36a739c0f2a16df.svg";
export { ForwardRef as ReactComponent };